/*
*
* @module : Topics
* @file : Topics.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of Home
*
* Created on : 09-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 19-Oct-2019
*/

import React from 'react';
import {Link} from 'react-router-dom';
import TopicService from '../../services/TopicService/TopicService';
import Translation from '../../language/Translation';

class Topics extends React.Component
{
	constructor()
	{
		super();
		this.translation = new Translation();
		this.state = {
			topics:[],
			translation:{
				'topics_v1':this.translation.getText('topics_v1')
				},
		};

		this.topicService = new TopicService();
	}

	componentDidMount()
	{
		this.topicService.getAllTopic().then(response=>{
			//console.log(response);
			this.setState({topics:response});
			sessionStorage.setItem('session_id', response.session_id);
		});

	}

	
	renderTopics= () =>
	{
		let topics = this.state.topics;
		if(topics.status==='1')
		{
		return Object.keys(topics.topics).map(function(key) {
				return <li key={key}>
				<Link to={`/topics/${topics.topics[key].id}/question/`}>
					<i className={`icon icon ${topics.topics[key].icon}`}></i> {topics.topics[key].name}
				</Link>
				</li>;
		});
		//console.log(topics.topics);
		}
		//console.log(topics);
	}

	render()
	{
		return (
			<React.Fragment>
			  <div className="content-box-area list-area">
				<div className="default-heading">
				  <h2>{this.state.translation.topics_v1}</h2>
				</div>
				<ul className="listing">
					{this.renderTopics()}
            	</ul>
             </div>
			</React.Fragment>
		);
	}
}

export default Topics;